module.exports = __webpack_public_path__ + "static/img_4461-433902551d7b151f6bf16c9a9990745d.webp";